import { getPrivatePostsAction } from "../redux/actions/postActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback, useMemo } from "react";
import SavedPost from "../components/post/SavedPost";
import ContentWithCards from "../components/shared/ContentWithCards";
import LoadMoreButton from "../components/shared/LoadMoreButton";
import CommonLoading from "../components/loader/CommonLoading";

const PrivatePosts = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);
  
  const privatePosts = useSelector((state) => state.posts?.privatePosts);
  const totalPrivatePosts = useSelector((state) => state.posts?.totalPrivatePosts);
  
  const LIMIT = 10;

  useEffect(() => {
    const fetchPrivatePosts = async () => {
      setIsLoading(true);
      await dispatch(getPrivatePostsAction(LIMIT, 0));
      setIsLoading(false);
    };
    fetchPrivatePosts();
  }, [dispatch, LIMIT]);

  const handleLoadMore = useCallback(() => {
    setIsLoadMoreLoading(true);
    const currentLength = privatePosts?.length || 0;
    dispatch(getPrivatePostsAction(LIMIT, currentLength)).finally(() => {
      setIsLoadMoreLoading(false);
    });
  }, [dispatch, LIMIT, privatePosts?.length]);

  const memoizedPosts = useMemo(() => {
    return privatePosts?.map((post) => (
      <SavedPost key={post._id} post={post} />
    )) || [];
  }, [privatePosts]);

  if (isLoading) {
    return (
      <ContentWithCards>
        <div className="flex justify-center items-center py-8">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );
  }

  return (
    <ContentWithCards>
      {privatePosts && privatePosts.length > 0 ? (
        <>
          <div className="w-full space-y-3 flex flex-col items-center max-w-3xl mx-auto overflow-visible">
            {memoizedPosts}
          </div>
          
          {/* Load More Button */}
          {privatePosts.length >= LIMIT && privatePosts.length < totalPrivatePosts && (
            <LoadMoreButton
              onClick={handleLoadMore}
              isLoading={isLoadMoreLoading}
              text="Load More Private Posts"
            />
          )}
        </>
      ) : (
        <div className="w-full bg-white border rounded-lg p-8 text-center max-w-3xl mx-auto">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">No private posts</h3>
          <p className="text-gray-500 mb-4 font-roboto-flex">You haven't created any private posts yet.</p>
        </div>
      )}
    </ContentWithCards>
  );
};

export default PrivatePosts;
